export const HOME_ROUTES = {
  home: "/",
  companyHome: "/company/:companyId",
  articles: "/articles/:categoryId",
  article: "/articles/:categoryId/:articleId",
} as const;
